import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `@@quizfolder.rpc`,
    services: {
        results: {
            parameters: [{ name: 'select', type: 'object', optional: true }]
        },
        one_result: {
            parameters: [{ name: 'qrid', type: 'number', optional: false }]
        },
        questionresults: {
            parameters: [
                { name: 'qrid', type: 'number', optional: false },
                { name: 'select', type: 'object', optional: true }
            ]
        },
        update_annotation: {
            parameters: [{ name: 'userid', type: 'string', optional: false }]
        },
        possible_testbanks: {
            parameters: [{}]
        },
        quiz_selectors: {
            parameters: [{}]
        },
        quiz_qorders: {
            parameters: [{}]
        },
        quiz_workflows: {
            parameters: [{}]
        },
        progression: {
            parameters: []
        },
        score_by_module: {
            parameters: []
        }
    }
});
export default svc;
